// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".legacy." + {"2897":"1bdd0fb3ec333beaa2f2","3490":"6867a60f2801c6d1b6af"}[chunkId] + ".js";
};